
define('modules/application/system-selection-multi',[
    'app',
    'backbone',
    'modules/application/header',
    'modules/application/subheader',
    'modules/application/wizard/classes/kits/audioVideoKits',
    'modules/application/wizard/classes/kits/automationKits',
    'modules/application/wizard/classes/kits/automationSimpleKits',
    'modules/application/wizard/classes/kits/energyManagementKits',
    'modules/application/wizard/classes/kits/intrusionDetectionKits',
    'modules/application/wizard/classes/kit',
    "./popup"
  ],

  function(app, Backbone, Header, Subheader, AudiovideoKits, AutomationKits, AutomationSimpleKits, EnergyManagementKits, IntrusionDetectionKits, Kit, Popup) {

    // Create a new module
    var SystemSelectionMulti = app.module();

    SystemSelectionMulti.Model = Backbone.Model.extend({

      defaults: {
        kits: []
      },

      initialize: function() {
        var retrievedCategorySystems = [],
          retrievedAccessoryLines = [],
          retrievedKit = [];

        this.kits = [];

        window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen", this.accessoryLineChosenEventHandler);
        window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen", this.accessoryLineChosenEventHandler, this);

        this.retrieveAccessoryLine();
        this.retrieveCategorySystem();
        //this.retrieveKit();
        window.BticinoS4B.eventAggregator.trigger("accessoryLine:chosen", window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
      },

      retrieveKit: function() {
        var self = this;
      },

      accessoryLineChosen: function(idColors, idAccessoryLine) {
        if (!idColors)
          idColors = null;

        var line = _.filter(window.BticinoS4B.Instances.Models.ApplicationModel.get('accessoryLines'), function(iterableLine) {
          return iterableLine.id === idAccessoryLine;
        })[0];
        var color = _.filter(line.colors, function(iterableColor) {
          return iterableColor.id === idColors;
        })[0];

        if (color.id) {
          window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenColor", color);
          window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenLine", line);
          window.BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", color.accessoryLineId);
        } else {
          window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenColor", null);
          window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenLine", line);
          window.BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", line.id);
        }

        window.BticinoS4B.eventAggregator.trigger("accessoryLine:chosen", window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));

        $('#serieProgettoLabel').html(window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine").name);

        if (idColors) {
          $('#coloreLabel').html(window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor").name);
        } else {
          $('#coloreLabel').html('-');
        }
      },

      retrieveAccessoryLine: function() {
        var self = this,
          successCallback = function(data) {
            //console.log(data);
            for (var i = 0; i < data.lines.length; i++) {
              for (var j = 0; j < data.lines[i].colors.length; j++) {
                //console.log(data.lines[i].colors[j]);

                if (data.lines[i].colors[j].accessoryLineId == '0') {
                  data.lines[i].colors[j].image = '';
                } else if (data.lines[i].colors[j].accessoryLineId == '4') {
                  data.lines[i].colors[j].image = '/assets/img/4.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '5') {
                  data.lines[i].colors[j].image = '/assets/img/5.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '8') {
                  data.lines[i].colors[j].image = '/assets/img/8.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '13') {
                  data.lines[i].colors[j].image = '/assets/img/13.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '14') {
                  data.lines[i].colors[j].image = '/assets/img/14.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '21') {
                  data.lines[i].colors[j].image = '/assets/img/21.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '31') {
                  data.lines[i].colors[j].image = '/assets/img/31.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '32') {
                  data.lines[i].colors[j].image = '/assets/img/32.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '33') {
                  data.lines[i].colors[j].image = '/assets/img/33.jpg';
                }
              }
            }
            retrievedAccessoryLines = data.lines;

            // set the first value as default
            if ((retrievedAccessoryLines && !window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLines")) ||
              (!window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine") && !window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor"))) {
              if (!window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLines"))
                window.BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLines", retrievedAccessoryLines);
              window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenLine", retrievedAccessoryLines[1]);
              window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenColor", retrievedAccessoryLines[1].colors[0]);
              window.BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", retrievedAccessoryLines[1].colors[0].accessoryLineId);
            }

            //self.accessoryLineChosen(retrievedAccessoryLines[1].colors[0].id, retrievedAccessoryLines[1].id);
            return retrievedAccessoryLines;
          },
          failCallback = function(e) {
            console.log(e);
          };
        window.BticinoS4B.Instances.Services.wizardServices.getAccessoryLines(successCallback, failCallback, self);
      },

      retrieveKitsForTheCurrentSystems: function() {
        var systems = window.BticinoS4B.Instances.Models.ApplicationModel.get("systems"),
          self = this,
          kits = self.get('kits'),
          i = 0,
          systemId,
          triggerEmpty = function(idSystem) {
            self.trigger('kit:retrieved', [
              [], idSystem
            ]);
          },
          successCallback = function(data) {

            var valorizePackage = function(productsData) {

              productsData = productsData.products;
              var x = 0,
                y = 0;
              var mainProduct = _.filter(productsData, function(iterableItem) {
                return iterableItem.mnemonic === 1;
              })[0];
              var secondaryProducts = _.filter(productsData, function(iterableItem) {
                return iterableItem.mnemonic !== 1;
              });

              data.packages[i] = _.extend(data.packages[i], mainProduct);
              data.packages[i].secondaryProducts = secondaryProducts;

              for (x = 0; x < data.packages.length; x++) {
                kits[data.packages[x].systemId] = data.packages[x];
                //kits[data.packages[x].systemId] = data.packages;
                self.set('kits', kits);
                self.trigger('kit:retrieved', [data.packages, data.packages[x].systemId]);
              }
            };

            //Retrieving articles
            for (i = 0; i < (data.packages ? data.packages.length : 0); i++) {
              window.BticinoS4B.Instances.Models.ApplicationModel.getProducts(data.packages[i].packageClassId, valorizePackage);
            }
            $('.loaderKit').fadeOut('fast');
            data.packages = null;
          };

        //Retrieving kits
        for (var j = 0, length = systems.length; j < length; j++) {
          systemId = systems[j].id;
          if (systems[j].specialData && systems[j].specialData.kitWizardChoice) {
            window.BticinoS4B.Instances.Services.wizardServices.getPackagesByIdWizardChoice(systems[j].specialData.kitWizardChoice, window.BticinoS4B.Instances.Models.ApplicationModel.get('accessoryLineId'), successCallback, [systemId], this);
          } else {
            triggerEmpty(systemId);
          }
        }

      },

      accessoryLineChosenEventHandler: function() {
        this.retrieveKitsForTheCurrentSystems();
      },

      retrieveCategorySystem: function() {
        var self = this,
          successCallback = function(data) {
            var tmpHashName = '';
            retrievedCategorySystems = [];

            for (var i = 0; i < data.CategorySystems.length; i++) {
              tmpHashName = '';

              if (data.CategorySystems[i].specialData) {
                data.CategorySystems[i].specialData = JSON.parse(data.CategorySystems[i].specialData);
              } else {
                data.CategorySystems[i].specialData = {};
              }

              if (data.CategorySystems[i].code == '#2') {
                tmpHashName = 'termoregolazione';
              } else if (data.CategorySystems[i].code == '#4') {
                tmpHashName = 'antintrusione';
              } else if (data.CategorySystems[i].code == '#5+6') {
                tmpHashName = 'audiovideo';
              } else if (data.CategorySystems[i].code == '#13+20') {
                tmpHashName = 'automazione';
              } else if (data.CategorySystems[i].code == '#13') {
                tmpHashName = 'automazioneSemplice';
              } else if (data.CategorySystems[i].code == '#21') {
                tmpHashName = 'gestioneEnergia';
                tmpAppName = tmpHashName;
              }

              wizardChoiceId = data.CategorySystems[i].specialData;

              retrievedCategorySystems[i] = {
                id: data.CategorySystems[i].code,
                name: data.CategorySystems[i].caption,
                hashName: tmpHashName,
                appName: tmpHashName,
                idbus: data.CategorySystems[i].idbus,
                busposition: data.CategorySystems[i].busposition,
                description: data.CategorySystems[i].description,
                specialData: data.CategorySystems[i].specialData
              };

            }
            window.BticinoS4B.Instances.Models.ApplicationModel.set("systems", retrievedCategorySystems);
            return retrievedCategorySystems;
          };

        window.BticinoS4B.Instances.Services.wizardServices.getEnabledCategorySystemListByLocalization('ITA', successCallback, [], self);
      }
    });

    SystemSelectionMulti.View = Backbone.View.extend({
      id: "system-selection",
      tagName: "section",
      template: "application/system-selection-multi",
      events: {
        //"click a": "openSystemWindow",
        'click .addSystem-button': 'addSystemEventHandler',
        'click .importSystem-button': 'importSystemEventHandler',
        'click .deleteSystem-button': 'requestDeleteSystem',
        'click .colorSlides button': 'selectColorLine',
        'click .buttonContainer a': 'checkToken'
      },
      checkToken: function() {
        BticinoS4B.checkTokenCookie();
      },

      serialize: function() {
        return {
          app: app,
          buses: app.buses,
          systems: window.BticinoS4B.Instances.Models.ApplicationModel.get('systems')
        };
      },

      initialize: function() {
        this.model = new SystemSelectionMulti.Model();
        // BticinoS4B.Instances.Models.ApplicationModel.systemSelectionModel = new SystemSelection.Model();
        //var systems = this.model.retrieveCategorySystem();
        // window.BticinoS4B.eventAggregator.unbind("language:changed", null, this);
        window.BticinoS4B.Instances.Models.systemSelectionMultiModel = this.model;
        window.BticinoS4B.eventAggregator.bind("language:changed", this.render, this);
        window.BticinoS4B.eventAggregator.bind("language:changed", window.BticinoS4B.Instances.Models.systemSelectionMultiModel.retrieveCategorySystem, this);
        this.model.bind('kit:retrieved', this.kitRetrievedEventHandler, this);
        BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", null);
        // $.cookie('solution', JSON.stringify(window.BticinoS4B.solution));
      },

      kitRetrievedEventHandler: function(addedKits) {
        var kitSection;
        var currentKit;
        var fetchedKits = [];

        if (addedKits[1]) {
          kitSection = this.$el.find('#system-' + addedKits[1].replace('#', '').replace('+', '-')).find('.kitsContainer');

          // if(addedKits.length>0)
          for (var i = 0; i < addedKits[0].length; i++) {
            if (addedKits[0][i].specialVars) {
              currentKit = addedKits[0][i];
              if (currentKit.specialVars.referenceAccessoryLines) {
                for (var j = 0; j < currentKit.specialVars.referenceAccessoryLines.length; j++) {
                  //console.log(currentKit);
                  if (currentKit.specialVars.referenceAccessoryLines[j] == window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId") && addedKits[1] == currentKit.systemId) {

                    // console.log(currentKit.specialVars.referenceAccessoryLines);
                    fetchedKits.push(currentKit);
                  }

                }
              } else {
                if (addedKits[1] == currentKit.systemId)
                  fetchedKits.push(currentKit);
              }
            }
          }
        }

        kitSection.find('.loaderKit').fadeOut('fast', function() {
          var toInsert;
          // kitSection.hide();
          $(this).css('display', 'block');
          // kitSection.fadeIn('fast');
          kitSection.find('.kitDetail').remove();
          for (var i = 0, length = fetchedKits.length; i < length; i++) {
            toInsert = new Kit.View({
              model: new Kit.Model(fetchedKits[i]),
              template: 'application/kit'
            });
            toInsert.render();
            kitSection.append(toInsert.$el.html());
            if (i === 0 && kitSection.find('.insertKitLabel').length === 0) {
              kitSection.prepend('<p class="insertKitLabel">' + $.i18n._("IDS_W1_9157") + '</p>');
            }
          }
          window.customizeFormElements.call();
          $(this).css('display', 'none');


        });
      },

      addSystemEventHandler: function(e) {
        // var systemCode = e.currentTarget.attributes.idsystem.value,
        //   systemName = e.currentTarget.attributes.namesystem.value,
        //   newSystem = {
        //     id: systemCode,
        //     appName: systemName
        //   };
        // app.system = newSystem;
        // window.BticinoS4B.Instances.Models.ApplicationModel.set("systemId", systemCode);
        // window.BticinoS4B.eventAggregator.trigger("system:changed", app.system);
        var idContainer = e.currentTarget.parentElement.parentElement.parentElement.id;
        if (idContainer) {
          $("#" + idContainer).find('input:checked').each(function() {
            //console.log($(this).attr("packageid"));
            BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", $(this).attr("packageid"));
          });
        }

      },

      requestDeleteSystem: function(e) {
        if (confirm('Desideri eliminare il sistema inserito?')) {
          var systemCode = e.currentTarget.attributes.idsystem.value;
          this.deleteSystemEventHandler(systemCode);
        } else {
          console.log('requestDeleteSystem: false');
        }
      },

      deleteSystemEventHandler: function(systemCode) {

        switch (systemCode) {
          case "#2":
            BticinoS4B.solution.thermoregulation = {};
            BticinoS4B.solution.thermoregulation.inserted = false;
            BticinoS4B.modelToLoad.thermoregulation = null;
            //alert('DELETE BticinoS4B.solution.thermoregulation');
            break;
          case "#4":
            BticinoS4B.solution.intrusionDetection = {};
            BticinoS4B.solution.intrusionDetection.inserted = false;
            BticinoS4B.modelToLoad.intrusionDetection = null;
            //alert('DELETE BticinoS4B.solution.intrusionDetection');
            break;
          case "#5+6":
            BticinoS4B.solution.audioVideo = {};
            BticinoS4B.solution.audioVideo.inserted = false;
            BticinoS4B.modelToLoad.audioVideo = null;
            //alert('DELETE BticinoS4B.solution.audioVideo');
            break;
          case "#13+20":
            BticinoS4B.solution.automation = {};
            BticinoS4B.solution.automation.inserted = false;
            BticinoS4B.modelToLoad.automation = null;
            //alert('DELETE BticinoS4B.solution.automation');
            break;
          case "#13":
            BticinoS4B.solution.automationSimple = {};
            BticinoS4B.solution.automationSimple.inserted = false;
            BticinoS4B.modelToLoad.automationSimple = null;
            //alert('DELETE BticinoS4B.solution.automationSimple');
            break;
          case "#21":
            BticinoS4B.solution.energyManagement = {};
            BticinoS4B.solution.energyManagement.inserted = false;
            BticinoS4B.modelToLoad.energyManagement = null;
            //alert('DELETE BticinoS4B.solution.energyManagement');
            break;
        }
        //trick to refresh view
        window.BticinoS4B.eventAggregator.trigger("language:changed");
      },

      generateDataFromProviderImport: function() {
        var generateDataFromProvider = function() {
          var that = this,
            dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");
          window.BticinoS4B.eventAggregator.trigger("modelDeliver:request", this);
          BticinoS4B.Instances.Models.ApplicationModel.startAutomaticCalculation();

          var dataToSend = {};

          //ItemListByPackage
          dataToSend.itemListByPackage = dataProvider.retrieveMaterialOverviewInReportVersion();

          //ItemListByProduct
          dataToSend.itemListByProduct = {
            productInPriceList: {
              section: $.i18n._("IDS_W1_9034"),
              items: []
            },
            productNotInPriceList: {
              section: $.i18n._("IDS_W1_9094"),
              items: []
            }
          };

          var materialList = dataProvider.retrieveMaterialListInReportVersion();
          dataToSend.itemListByProduct.productInPriceList.items = materialList.productsInPriceList;
          dataToSend.itemListByProduct.productNotInPriceList.items = materialList.productsNotInPriceList;

          dataToSend.grandTotal = dataProvider.getGrandTotal();

          return dataToSend;
        };
        if (window.BticinoS4B.modelToLoad.audioVideo)
          window.BticinoS4B.modelToExport.audioVideo = generateDataFromProvider();
        else if (window.BticinoS4B.modelToLoad.thermoregulation)
          window.BticinoS4B.modelToExport.thermoregulation = generateDataFromProvider();
        else if (window.BticinoS4B.modelToLoad.intrusionDetection)
          window.BticinoS4B.modelToExport.intrusionDetection = generateDataFromProvider();
        else if (window.BticinoS4B.modelToLoad.automation)
          window.BticinoS4B.modelToExport.automation = generateDataFromProvider();
        else if (window.BticinoS4B.modelToLoad.automationSimple)
          window.BticinoS4B.modelToExport.automationSimple = generateDataFromProvider();
        else if (window.BticinoS4B.modelToLoad.energyManagement)
          window.BticinoS4B.modelToExport.energyManagement = generateDataFromProvider();
      },

      importSystemEventHandler: function(e) {
        var systemCode = e.currentTarget.attributes.idsystem.value;
        var accessoryLine = window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");
        window.BticinoS4B.vars.systemToImport = systemCode;
        window.BticinoS4B.Instances.Views.headerView.importPopup.setSystem(systemCode);
        window.BticinoS4B.Instances.Views.headerView.importPopup.show();
        // window.BticinoS4B.Instances.Views.headerView.importPopup.show(this.generateDataFromProviderImport);
        //alert('importSystemEventHandler');
      },

      selectColorLine: function(e) {
        var self = this;
        // this.$el.find('.kitDetail').fadeOut('fast', function(){
        //   self.$el.find('.loaderKit').fadeIn('fast');
        // });
        self.checkToken();
        if (!self.isInsertedSystem()) {
          var idColors = e.currentTarget.attributes.nameColors.value,
            idAccessoryLine = e.currentTarget.attributes.nameAccessoryLine.value;
          this.model.accessoryLineChosen(idColors, idAccessoryLine);

          $('.colorSlides button.selected').removeClass('selected');
          e.currentTarget.className = 'selected';
        } else {
          alert("" + $.i18n._("IDS_W1_9147") + "");
        }
      },

      openSystemWindow: function(e) {
        e.preventDefault();
        window.open(e.currentTarget.href);
        return false;
      },

      afterRender: function() {
        this.sliderSystem();
        this.displayDescription();
      },

      beforeRender: function() {
        // temp -> questo ci permette ti unbind tutti gli eventi delle classi non più necessarie
        if (!window.BticinoS4B.eventAggregatorCleaned) {
          window.BticinoS4B.eventAggregatorCleaned = jQuery.extend(true, {}, window.BticinoS4B.eventAggregator);
        } else {
          window.BticinoS4B.eventAggregator = jQuery.extend(true, {}, window.BticinoS4B.eventAggregatorCleaned);
        }
        // fine temp

        if ($('#serieProgettoLabel').html() == 'nessuna') {
          $('#serieProgettoLabel').html(window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine").name);
        }
        // $('#serieProgettoLabel').html(line.name);
        if ($('#coloreLabel').html() == 'nessuno') {
          idColors = window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor").name;
          if (idColors) {
            $('#coloreLabel').html(idColors);
          } else {
            $('#coloreLabel').html('-');
          }
        }
      },

      sliderSystem: function() {
        var that = this;
        if ($('.flexslider').length > 0) {
          //se c'è almeno un inserito non selezionare slider!!!
          // if(BticinoS4B.solution.audioVideo.inserted)
          var start = 0;
          var lineSelected = 0;
          if (window.BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenLine.id)
            lineSelected = window.BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenLine.id;
          if (lineSelected)
            start = $("li#" + lineSelected, ".flexslider").attr("positionId");
          $('.flexslider').flexslider({
            animation: 'slide',
            prevText: '', //String: Set the text for the "previous" directionNav item
            nextText: '',
            slideshow: false,
            startAt: start
          });
          that.selectedColorImportSystem(lineSelected);
        }
      },

      selectedColorImportSystem: function(lineSelected) {
        var colorId = 0;
        var lineId = lineSelected;
        if (window.BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenColor) {
          colorId = window.BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenColor.id;
        }
        this.model.accessoryLineChosen(colorId, lineId);
        $('.colorSlides button.selected').removeClass('selected');
        $('.colorSlides button[nameaccessoryline=' + lineId + ']').each(function() {
          if (colorId) {
            if ($(this).attr('namecolors') == colorId)
              $(this).addClass('selected');
          } else
            $(this).addClass('selected');
        });
      },

      isInsertedSystem: function() {
        if (window.BticinoS4B.solution.thermoregulation.inserted || window.BticinoS4B.solution.audioVideo.inserted || window.BticinoS4B.solution.automation.inserted || window.BticinoS4B.solution.intrusionDetection.inserted || window.BticinoS4B.solution.automationSimple.inserted || window.BticinoS4B.solution.energyManagement.inserted)
          return true;
        else
          return false;
      },

      displayDescription: function() {
        var parentDescription;
        var defaultHeight = 50;
        var height = 0;
        $(".descriptionContinue").toggle(function() {
          parentDescription = $(this).parent().find('.descriptionBus');
          var curHeight = parentDescription.height();
          if (curHeight == defaultHeight) {
            height = parentDescription.css('height', 'auto').height();
            parentDescription.css('height', curHeight);
          } else
            height = curHeight;
          parentDescription.animate({
            height: height
          }, 200);
        }, function() {
          parentDescription = $(this).parent().find('.descriptionBus');
          parentDescription.animate({
            height: defaultHeight
          }, 200);
        });
      }
    });

    return SystemSelectionMulti;

  });